module.exports = __webpack_public_path__ + "img/KOB_FOS_logo_wht.dab4a3d5.svg";